<template>
  <b-modal id="mass-comments-create-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`" centered
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal">{{ $t('idp.write_comment') }}</h5>
    </template>
    <div class="adp-p adp-p__grey mb-4">Для {{ activities.length }} программ / мероприятий или пожеланий</div>
    <template v-for="activity in activities">
      <div class="adp-p adp-p__grey">{{ activity.name }}</div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.comment') }}</label>
        <textarea rows="5" v-model="comment" class="adp-input adp-input-textarea"></textarea>
      </div>
    </template>
    <template #modal-footer>
      <button id="delete" class="btn btn-primary adp-btn adp-btn__large" @click="save()" style="margin-left: auto" :disabled="!comment.length">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>

import api from "../../api";

export default {
  name: "MassCommentsCreateModal",
  props: {
    activities: {
      type: Array,
      required: true,
    },
    viewerPernumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      comment: '',
    };
  },
  methods: {
    save() {
      let data = {
        pernumber: this.viewerPernumber,
        ids: this.activities.map(a => a.id),
        comment: this.comment,
      };
      api.massComment(data)
        .then(response => {
          if (response.status === 201) {
            this.$emit('comments-created');
          }
          this.comment = '';
        })
        .catch(err => {
          console.log(err)
        });
      this.$bvModal.hide('mass-comments-create-modal');
    },
    onShow() {
      this.comment = '';
    },
  },
}
</script>
